<script setup lang="ts">
/* ===========================================================================
   ui-delta — MenuBurger
   ---------------------------------------------------------------------------
   ADDS:      A two-bar menu glyph that turns into a cross when the header's
              menu is open — one element morphing, not two icons swapped.
   UPSTREAM:  @ui AppHeader takes `menuIcon` / `menuOpenIcon` components and
              swaps them. Passing this component as BOTH keeps the element
              alive across the swap, and the open state is read from the
              button's own `--active` class, so the bars animate.
   AT MERGE:  Offer as the header's default menu glyph.
   =========================================================================== */
</script>

<template>
  <span class="menu-burger" aria-hidden="true">
    <span class="menu-burger__bar" />
    <span class="menu-burger__bar" />
  </span>
</template>

<!-- Unscoped on purpose: the open state lives on the library's button. -->
<style>
.menu-burger {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
}

/* Both bars sit at the vertical centre and are pushed apart by a transform,
   so the open state is one transform per bar and the motion is a real morph. */
.menu-burger__bar {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 0;
  width: 20px;
  height: 2px;
  border-radius: var(--radius-full);
  background: currentcolor;
  transition: transform 200ms ease;
}

.menu-burger__bar:first-child {
  transform: translateY(-4px);
}

.menu-burger__bar:last-child {
  transform: translateY(2px);
}

.app-header__menu-button--active .menu-burger__bar:first-child {
  transform: translateY(-1px) rotate(45deg);
}

.app-header__menu-button--active .menu-burger__bar:last-child {
  transform: translateY(-1px) rotate(-45deg);
}
</style>
